<template>
  <div :class="imgClass" class="coverImg" :style="'background-image: url('+(imgUrl ? (imgUrl+'?x-oss-process=image/resize,m_lfit,w_270') : returnImg())+');'"></div>
  <!-- <el-image :src="imgUrl" fit="contain"></el-image> -->
</template>

<script>
export default {
  props: {
    imgClass: {
      type: String,
      default: String
    },
    imgUrl: {
      type: String,
      default: String
    },
    defaultImg: {
      type: String,
      default: String
    }
  },
  methods: {
    returnImg() {
      return this.defaultImg;
    }
  }
};
</script>

<style scoped>
.coverImg {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
